import { Dispatch } from 'react';
import { post, put, get, remove } from 'communication/httpClient';
import { cleanObject } from 'utils/object';

import {
  LOAD_MESSAGES,
  MESSAGES_LOADED,
  MESSAGE_DELETED,
  SAVE_MESSAGE,
  LOAD_MESSAGE_TYPES,
  MESSAGE_TYPES_LOADED,
  MESSAGE_ADDED,
  RESET_MESSAGE_ERROR,
  SYNCING,
  SYNC_FAILED,
  CONTROL_MESSAGE_POPUP,
} from './actionTypes';
import { IMessagesAction, IMessagesActions, IMetaDataFullMessage } from './types';

export const initialActionsState = {
  loadMessages: () => {},
  deleteMessage: () => {},
  addMessage: () => {},
  loadMessageTypes: () => {},
  resetMessageError: () => {},
  setMessagePopUp: () => {},
};

export const getActions = (dispatch: Dispatch<IMessagesAction>): IMessagesActions => ({
  loadMessages: async (params, context = '') => {
    dispatch({ type: LOAD_MESSAGES });
    const { data, error } = await get('/api/messages', { params: cleanObject(params) });

    if (data) {
      dispatch({
        type: MESSAGES_LOADED,
        payload: { data, context },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },

  deleteMessage: async (id: string, callback?: () => void) => {
    dispatch({
      type: SYNCING,
    });
    const { data, error } = await remove(`/api/messages/${id}`);

    if (data || data === '') {
      dispatch({
        type: MESSAGE_DELETED,
        payload: id,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  saveMessage: async (message: IMetaDataFullMessage, id?: string, callback?: () => void) => {
    dispatch({
      type: SAVE_MESSAGE,
    });
    const handler = id ? put : post,
      resourceId = id || '';
    const { data, error } = await handler(`/api/messages/` + resourceId, message);

    if (data || data === '') {
      dispatch({
        type: MESSAGE_ADDED,
        payload: message,
      });
      if (callback) {
        callback();
      }
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadMessageTypes: async () => {
    dispatch({ type: LOAD_MESSAGE_TYPES });
    const { data, error } = await get('/api/messages/contexts');

    if (data || data === '') {
      dispatch({
        type: MESSAGE_TYPES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  setMessagePopUp: (isOpen) => {
    dispatch({
      type: CONTROL_MESSAGE_POPUP,
      payload: isOpen,
    });
  },
  resetMessageError: () => {
    dispatch({
      type: RESET_MESSAGE_ERROR,
    });
  },
});
